@if (isVisible$ | async) {
  <shared-loading-indicator class="loading-screen"></shared-loading-indicator>
}
